import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router";
import { AppRoutes } from "./app/routes";
import { AuthProvider } from "./auth/AuthContext";

const queryClient = new QueryClient();

/**
 * Unlike the dashboard, the router sits *outside* the auth gate: the Google
 * flow returns to `/auth/callback` in an unauthenticated tab, and that route
 * must render to finish signing in. The gate lives inside `AppRoutes`.
 */
export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </AuthProvider>
    </QueryClientProvider>
  );
}
